module.exports = __webpack_public_path__ + "static/img/200075.df883f2b.png";